import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { cn } from "../../lib/utils";
import {
    LayoutDashboard,
    FolderKanban,
    Users,
    MessageSquare,
    Settings,
} from "lucide-react";

const navItems = [
    { path: "/dashboard", label: "Dashboard", icon: LayoutDashboard },
    { path: "/projects", label: "Projets", icon: FolderKanban },
    { path: "/clients", label: "CRM", icon: Users },
    { path: "/messaging", label: "Messages", icon: MessageSquare },
    { path: "/settings", label: "Plus", icon: Settings },
];

export const MobileBottomNav = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const isActive = (path) => {
        if (path === "/dashboard") {
            return location.pathname === "/dashboard" || location.pathname === "/";
        }
        return location.pathname.startsWith(path);
    };

    return (
        <nav 
            className="mobile-bottom-nav fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-lg border-t border-border safe-area-bottom md:hidden"
            data-testid="mobile-bottom-nav"
        >
            <div className="flex items-center justify-around h-16 px-2">
                {navItems.map((item) => {
                    const Icon = item.icon;
                    const active = isActive(item.path);
                    
                    return (
                        <button
                            key={item.path}
                            onClick={() => navigate(item.path)}
                            className={cn(
                                "flex flex-col items-center justify-center flex-1 h-full py-2 px-1 transition-all duration-200 touch-manipulation",
                                "active:scale-95 active:opacity-80",
                                active 
                                    ? "text-primary" 
                                    : "text-muted-foreground hover:text-foreground"
                            )}
                            data-testid={`mobile-nav-${item.path.replace("/", "")}`}
                        >
                            <div className={cn(
                                "flex items-center justify-center w-10 h-10 rounded-xl transition-all",
                                active && "bg-primary/10"
                            )}>
                                <Icon className={cn(
                                    "w-5 h-5 transition-transform",
                                    active && "scale-110"
                                )} />
                            </div>
                            <span className={cn(
                                "text-[10px] font-medium mt-0.5 transition-all",
                                active && "font-semibold"
                            )}>
                                {item.label}
                            </span>
                        </button>
                    );
                })}
            </div>
        </nav>
    );
};

export default MobileBottomNav;
